import { useContext } from 'react';

import { CurrentPlatformContext } from '@dashboard/contexts/PlatformManager';

export default function usePlatformClient() {
  const context = useContext(CurrentPlatformContext);
  if (context === null) {
    throw new Error('usePlatformClient must be used within a PlatformManager');
  }
  return context.platformApiClient;
}
